import { Component, Input, OnInit } from '@angular/core';
import { ScenarioTest } from '../workflow.interface';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ScenarioDTO } from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-workflow-test',
    templateUrl: './workflow-test.component.html',
    styleUrls: ['./workflow-test.component.scss'],
    standalone: false
})
export class WorkflowTestComponent implements OnInit {

    @Input() workflowType: ScenarioDTO.TypeEnum;
    @Input() test: ScenarioTest;

    testForm: FormGroup;

    get isTransactional(): boolean {
        return this.workflowType === ScenarioDTO.TypeEnum.TRANSACTIONAL;
    }

    get isMarketing(): boolean {
        return this.workflowType === ScenarioDTO.TypeEnum.MARKETING;
    }

    get emailsControl(): AbstractControl | null {
        return this.testForm.get('testEmails');
    }

    constructor(
        private fb: FormBuilder
    ) { }

    ngOnInit(): void {
        this.initializeForm()
    }

    initializeForm(): void {
        const baseConfig = {
            testEmails: [
                this.test?.testEmails || '', [Validators.required, this.emailListValidator]
            ]
        };

        const formConfig = this.isTransactional
            ? {
                testPeriod: [
                    this.test ? [this.test.startDate, this.test.endDate] : ''
                ],
                ...baseConfig
            }
            : baseConfig

        this.testForm = this.fb.group(formConfig);
    }

    // Validateur personnalisé pour une liste d'emails séparés par des points-virgules
    private emailListValidator(control: AbstractControl): ValidationErrors | null {
        if (!control.value) {
            return null;
        }

        const emailList = control.value.map((email: string) => email.trim()).filter((email: string) => email);
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0.-]+\.[a-zA-Z]{2,}$/

        const invalidEmails = emailList.filter((email: string) => !emailRegex.test(email))

        if (invalidEmails.length > 0) {
            return {
                invalidEmails: {
                    invalid: invalidEmails,
                    message: `Email(s) invalide(s): ${invalidEmails.join(', ')}`
                }
            };
        }

        return null;
    }

    onTestScenario(): void {
        if (this.testForm.valid) {
            const formValue = { ... this.testForm.value }
            formValue.testEmails = this.getEmailsArray();
            console.log('Test du scénario avec les données:', formValue);
            console.log('Emails à tester:', formValue.testEmails);
        } else {
            console.log('Formulaire invalide');
            this.testForm.markAllAsTouched();
        }
    }

    public isFormValid(): boolean {
        return this.testForm?.valid || false;
    }

    public getFormValue(): any {
        const formValue = { ...this.testForm?.value };
        if (formValue.testEmails) {
            formValue.testEmails = this.getEmailsArray();
        }
        return formValue;
    }

    private getEmailsArray(): string[] {
        const emails = this.emailsControl?.value || '';
        return emails.map((email: string) => email.trim()).filter((email: string) => email);
    }
}
